import { SocketWebActionController } from '../../SocketActionController.ts';
import { SocketLobbySend } from '../../../../shared/scripts/socket/SocketLobbySend.ts';
import { DiscordInstance } from '../DiscordInstance.ts';
import { CustomLinkUtils } from '../../../../shared/scripts/ui_utils/CustomLinkUtils.ts';
import { UIUrlController } from '../../../../shared/scripts/ui_html/UIUrlController.ts';
import { UIPopupFunnelIncentiveController } from '../../ui_popup/UIPopupFunnelIncentiveController.ts';
import { UIDiscordCtaUtils } from '../../../../shared/scripts/UIDiscordCtaUtils.ts';
import { UIUtilsEjsVariables } from '../../../../shared/scripts/UIUtilsEjsVariables.ts';
export class SocketDiscordActionController extends SocketWebActionController {
    // eslint-disable-next-line class-methods-use-this
    onStateSessionState() {
        const discordInstance = DiscordInstance.getDiscordInstance();
        const voiceChannelId = discordInstance.voiceChannelId;
        const serverProfile = discordInstance.serverProfile;
        const roomId = CustomLinkUtils.extractRoomIdFromCustomLink(discordInstance.referralOrReactivationType, discordInstance.isInitialLoad) || UIUrlController.getRoomIdFromUrl();
        SocketLobbySend.joinChannel(voiceChannelId, serverProfile, discordInstance.isInitialLoad, roomId);
        UIPopupFunnelIncentiveController.showPopup(false);
    }
    onChannelRoomUpdate(roomData) {
        if (!UIUtilsEjsVariables.isUserOnDiscord || !this.uiManager) return;
        UIDiscordCtaUtils.updateDiscordCTAContent(this.uiManager.landingPage.playWithFriendsCTA, roomData);
        UIDiscordCtaUtils.updateDiscordCTAContent(this.uiManager.lobby.joinRoomButton, roomData);
        DiscordInstance.getDiscordInstance().loadingScreen.hideBackground();
    }
}
